import moment from 'moment'

export const sumTimeout = (oldTime: string, newTime: number) => {
  const sumTime = moment(oldTime).add(newTime, 'minutes').format()
  const [leftSide, rightSide] = sumTime?.split('T')
  const onlyTime = rightSide.split('-')[0]
  return `${leftSide} ${onlyTime}`
}
